import * as React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import {CompanyType} from '../../shared/CommonInterfaces';
import DocumentsService from '../../shared/services/DocumentsService';
import FlexeContext from '../../contexts/FlexeContext';
import ShipperInboundContext from '../contexts/ShipperInboundContext';
import InboundService from '../../shared/services/InboundService';
import ContainersService from '../../shared/services/ContainersService';
import UserService from '../../shared/services/UserService';
import WarehouseService from '../../shared/services/WarehouseService';
import PackingListService from '../../shared/services/PackingListService';
import InboundDeliveryDetails from './InboundDeliveryDetails';

interface Props {
  containerDeliveryId: number;
  authenticityToken: string;
}

const InboundDeliveriesRouter: React.FC<Props> = ({authenticityToken, containerDeliveryId}) => (
  <FlexeContext.Provider
    value={{
      authenticityToken
    }}
  >
    <ShipperInboundContext.Provider
      value={{
        inboundService: new InboundService(),
        documentsService: new DocumentsService(CompanyType.shipper),
        containersService: new ContainersService(authenticityToken),
        packingListService: new PackingListService(authenticityToken),
        userService: new UserService(authenticityToken),
        warehouseService: new WarehouseService(authenticityToken)
      }}
    >
      <Router>
        <Route
          path="/s/dropoffs/container/:id"
          render={() => (
            <InboundDeliveryDetails inboundId={containerDeliveryId} authenticityToken={authenticityToken} />
          )}
        />
      </Router>
    </ShipperInboundContext.Provider>
  </FlexeContext.Provider>
);

export default InboundDeliveriesRouter;
